import BranchesLocation from "../components/BranchesLocation";
import Breadcrumb from "../components/Breadcrumb";

const BranchLocationPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="Branch Location" />

      <BranchesLocation />
    </>
  );
};

export default BranchLocationPage;
